/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticketpagephaselive3Inputs */

const en_ticketpagephaselive3 = /** @type {(inputs: Ticketpagephaselive3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`On now`)
};

const de_ticketpagephaselive3 = /** @type {(inputs: Ticketpagephaselive3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Läuft`)
};

/**
* | output |
* | --- |
* | "On now" |
*
* @param {Ticketpagephaselive3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const ticketpagephaselive3 = /** @type {((inputs?: Ticketpagephaselive3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticketpagephaselive3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticketpagephaselive3(inputs)
	return de_ticketpagephaselive3(inputs)
});
export { ticketpagephaselive3 as "ticketPagePhaseLive" }